import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    fontFamily: '"Amazon Ember", Helvetica, Arial, sans-serif',
    fontSize: 12,
  },
  components: {
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          color: '#000000',
          '&.Mui-focused': {
            color: '#000000',
          },
        },
      },
    },
  },
});

export default theme;
